export class GameAudio {
  constructor() {
    this.context = null;
    this.master = null;
    this.muted = localStorage.getItem("flood-watch-muted") === "true";
  }

  unlock() {
    if (!this.context) {
      this.context = new AudioContext();
      this.master = this.context.createGain();
      this.master.gain.value = this.muted ? 0 : 0.22;
      this.master.connect(this.context.destination);
    }
    if (this.context.state === "suspended") this.context.resume();
  }

  toggle() {
    this.unlock();
    this.muted = !this.muted;
    this.master.gain.setTargetAtTime(this.muted ? 0 : 0.22, this.context.currentTime, 0.03);
    localStorage.setItem("flood-watch-muted", String(this.muted));
    return this.muted;
  }

  tone(frequency, duration = 0.1, type = "sine", delay = 0, gain = 0.45) {
    if (!this.context || this.muted) return;
    const start = this.context.currentTime + delay;
    const oscillator = this.context.createOscillator();
    const volume = this.context.createGain();
    oscillator.type = type;
    oscillator.frequency.setValueAtTime(frequency, start);
    volume.gain.setValueAtTime(0.001, start);
    volume.gain.exponentialRampToValueAtTime(gain, start + 0.015);
    volume.gain.exponentialRampToValueAtTime(0.001, start + duration);
    oscillator.connect(volume);
    volume.connect(this.master);
    oscillator.start(start);
    oscillator.stop(start + duration + 0.03);
  }

  jump() {
    this.tone(280, 0.12, "triangle", 0, 0.26);
    this.tone(430, 0.1, "triangle", 0.05, 0.2);
  }

  bounce() {
    this.tone(180, 0.2, "sine", 0, 0.5);
    this.tone(620, 0.22, "sine", 0.06, 0.35);
  }

  checkpoint() {
    [420, 560, 720].forEach((frequency, index) => this.tone(frequency, 0.18, "triangle", index * 0.08, 0.26));
  }

  pickup() {
    [680, 900].forEach((frequency, index) => this.tone(frequency, 0.12, "sine", index * 0.06, 0.23));
  }

  countdown(number) {
    this.tone(number === 0 ? 760 : 380, number === 0 ? 0.32 : 0.12, "square", 0, 0.15);
  }

  splash() {
    this.tone(120, 0.45, "sawtooth", 0, 0.16);
  }

  finish() {
    [440, 554, 659, 880].forEach((frequency, index) => this.tone(frequency, 0.35, "triangle", index * 0.09, 0.25));
  }
}
